import { useState, FC } from "react";
import { GridSelectorModalWindow } from "../../../components/modalWindows/GridSelectorModalWindow";
import { GoodsCodeGrid, GoodsCodeGridPluginSettings } from ".";
import { v4 as uuidv4 } from 'uuid';
import { IEntitySimpleDTO } from "../../../libs/coreapi-dto/@types/common";
import { useTranslation } from "react-i18next";

const GoodsCodeSelectorModal: FC<IGridSelectorModalProps> = (props) => {
    const [entity, setEntity] = useState<IEntitySimpleDTO>(props.selectedEntity ?? {} as IEntitySimpleDTO)
    const gridId = uuidv4();
    const plugin = GoodsCodeGridPluginSettings
    const { t } = useTranslation();

    return (
        <GridSelectorModalWindow
            gridDisplayName={plugin?.name ?? t('directory.goods.supplierCodes')}
            ok={{ onClick: () => props.ok?.(entity) }}
            cancel={{ onClick: () => props.cancel?.() }}
        >
            {
                plugin
                    ? <GoodsCodeGrid gridId={gridId} plugin={plugin}
                        onSelect={(row) => row && setEntity({ idGlobal: row.idGlobal, displayName: row.idGlobal })}
                        onDoubleClick={(row) => {
                            setEntity({ idGlobal: row.idGlobal, displayName: row.idGlobal })
                            props.ok?.(entity)
                        }}
                    />
                    : <p> {t('general.directoryNotConfigured')} </p>
            }
        </GridSelectorModalWindow>
    )
}

export default GoodsCodeSelectorModal